"use strict";
/**
 * 提供绘制 shape 时的一些通用方法
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("@antv/util");
function splitPoints(obj) {
    var points = [];
    var x = obj.x;
    var y = obj.y;
    y = _.isArray(y) ? y : [y];
    _.each(y, function (yItem, index) {
        var point = {
            x: _.isArray(x) ? x[index] : x,
            y: yItem,
        };
        points.push(point);
    });
    return points;
}
exports.splitPoints = splitPoints;
// rename addFillAttrs
function setFillStyle(attrs, cfg) {
    var color = cfg.color, opacity = cfg.opacity;
    if (color) {
        attrs.fill = color;
    }
    if (_.isNumber(opacity)) {
        attrs.opacity = attrs.fillOpacity = opacity;
    }
}
exports.setFillStyle = setFillStyle;
// rename addStrokeAttrs
function setStrokeStyle(attrs, cfg) {
    var color = cfg.color, opacity = cfg.opacity;
    if (color) {
        attrs.stroke = color;
    }
    if (_.isNumber(opacity)) {
        attrs.opacity = attrs.strokeOpacity = opacity;
    }
}
exports.setStrokeStyle = setStrokeStyle;
//# sourceMappingURL=shape.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/util/shape.js
// module id = 110
// module chunks = 37